import { render, staticRenderFns } from "./VNotification.vue?vue&type=template&id=5b0c6b4a&"
import script from "./VNotification.vue?vue&type=script&lang=js&"
export * from "./VNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports